import React from 'react'
import { TooltipList } from 'packages/ui/Graph'

const DISK_1_COLOR = '#3B82F6'
const DISK_2_COLOR = '#F59E0B'

interface GraphDataPoint {
  timestamp: string
  time: string
  formattedTime: string
  disk_1?: number
  disk_2?: number
}

interface CCTVDiskTooltipProps {
  active?: boolean
  label?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: any[]
  availableDisks: string[]
}

const CCTVDiskTooltip: React.FC<CCTVDiskTooltipProps> = ({ active, label, payload, availableDisks }) => {
  if (!active || !payload || !payload.length) return null

  const dataPoint = payload[0]?.payload as GraphDataPoint
  const list: { color: string; label: string; value: string }[] = []

  if (availableDisks.includes('1')) {
    const disk1 = payload.find(({ dataKey }) => dataKey === 'disk_1')
    const disk1Value = typeof disk1?.value === 'number' ? disk1.value : 0
    list.push({
      color: DISK_1_COLOR,
      label: disk1?.name || 'Disk 1',
      value: `${disk1Value.toFixed(2)}%`
    })
  }

  if (availableDisks.includes('2')) {
    const disk2 = payload.find(({ dataKey }) => dataKey === 'disk_2')
    const disk2Value = typeof disk2?.value === 'number' ? disk2.value : 0
    list.push({
      color: DISK_2_COLOR,
      label: disk2?.name || 'Disk 2',
      value: `${disk2Value.toFixed(2)}%`
    })
  }

  return (
    <TooltipList
      title={dataPoint?.formattedTime || label}
      list={list}
    />
  )
}

export default CCTVDiskTooltip